import { render, staticRenderFns } from "./views.vue?vue&type=template&id=5cf0217e&scoped=true"
import script from "./views.vue?vue&type=script&lang=js"
export * from "./views.vue?vue&type=script&lang=js"
import style0 from "./views.vue?vue&type=style&index=0&id=5cf0217e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0217e",
  null
  
)

export default component.exports